import CoursePlanEventLogContainer from './CoursePlanEventLogContainer';
export default CoursePlanEventLogContainer;
